import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	enterQueryAriaLabel: {
		id: 'atlassian-intelligence.search-field.enter-query-aria-label',
		defaultMessage: 'Enter your natural language query, for example:',
		description: 'The aria-label for the AI inline prompt textfield',
	},
});
